import * as React from "react";

export interface Props {
    on?: any;
    childRef?: React.RefObject<any>;
}

export class EventDetector extends React.Component<Props> {

    private divRef: React.RefObject<any>;

    constructor(props) {
        super(props);
        this.divRef = this.props.childRef || React.createRef();
    }

    public componentDidMount() {
        if (this.props.on) {
            Object.entries(this.props.on)
                .forEach(([eventName, callback]) => {
                    if (typeof callback === "function") {
                        this.divRef.current.addEventListener(eventName, callback);
                    }
                });
        }
    }

    public render() {
        return (
            <div
                ref={this.divRef}
                style={{height: "100%"}}
            >
                {this.props.children}
            </div>
        );
    }
}
